import { Input } from '@heidi/design-system/input';

type Props = {
  otherSpecialty?: string;
  setOtherSpecialty: (value: string) => void;
  className?: string;
  wrapperClassName?: string;
};

const ClinicianOtherInput = ({
  otherSpecialty,
  setOtherSpecialty,
  className,
  wrapperClassName,
}: Props) => {
  return (
    <Input
      type="text"
      id="other-specialty"
      wrapperClassName={wrapperClassName}
      className={className}
      value={otherSpecialty}
      onChange={(e) => setOtherSpecialty(e.target.value)}
      placeholder="Please specify"
    />
  );
};

export default ClinicianOtherInput;
